<mat-card class="page-header mat-elevation-z0">
    <mat-card-title>System Events</mat-card-title>
    <mat-card-subtitle>Search and review system events by instance and parent entity</mat-card-subtitle>
</mat-card>

<mat-divider></mat-divider>

<mat-card class="search-form-card">
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
        <div class="form-row">
            <mat-form-field appearance="outline" class="form-field small-field">
                <mat-label>Instance (State/Environment)</mat-label>
                <mat-select formControlName="stateEnv">
                    <mat-option *ngFor="let instance of instances" [value]="instance.State?.toLowerCase()">
                        {{instance.Name}} - {{instance.State?.toLowerCase()}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="searchForm.get('stateEnv')?.invalid">
                    Instance is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field small-field">
                <mat-label>Parent Type</mat-label>
                <mat-select formControlName="parentType">
                    <mat-option *ngFor="let type of parentTypes" [value]="type.value">
                        {{type.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field small-field">
                <mat-label>Event Type</mat-label>
                <mat-select formControlName="eventType">
                    <mat-option *ngFor="let type of eventTypes" [value]="type.value">
                        {{type.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field small-field">
                <mat-label>Parent ID (Process/Zoning Code ID)</mat-label>
                <input matInput formControlName="parentId" placeholder="Enter parent entity ID">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field small-field created-at-field">
                <mat-label>Created At Start</mat-label>
                <input matInput type="date" formControlName="createdAtStart">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field small-field created-at-field">
                <mat-label>Created At End</mat-label>
                <input matInput type="date" formControlName="createdAtEnd">
            </mat-form-field>

            <div class="button-group">
                <button mat-icon-button color="primary" type="submit" [disabled]="searchForm.invalid"
                    matTooltip="Search Events">
                    <mat-icon>search</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="onReset()" matTooltip="Reset">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>
    </form>
</mat-card>

<mat-divider [hidden]="!showResults"></mat-divider>

<mat-card class="results-card" [hidden]="!showResults">
    <mat-card-title>Events List</mat-card-title>
    <div class="events-list-wrapper">
        <app-paginated-process-list-component [stateEnv]="selectedStateEnv" [parentId]="selectedParentId"
            [parentType]="selectedParentType" [eventType]="selectedEventType" [createdAtStart]="selectedCreatedAtStart"
            [createdAtEnd]="selectedCreatedAtEnd" [refreshToken]="refreshToken" [showPaginatorOnTop]="true"
            [showParentType]="true">
        </app-paginated-process-list-component>
    </div>
</mat-card>